import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthInactivityService } from '../services/auth-inactivity.service';

@Injectable({
  providedIn: 'root'
})
export class InactivityGuard  {

  constructor(
    private authInactivityService: AuthInactivityService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Verificar si el usuario está autenticado
    if (this.authInactivityService.isLoggedIn()) {
      // Reiniciar timer de inactividad en cada navegación
      this.authInactivityService.restartInactivityTimer();
      return true;
    } else {
      // Si no está autenticado, redirigir al login
      this.router.navigate(['/login']);
      return false;
    }
  }
}
